import * as inView from "../libs/in-view.min.js";
import $ from "../libs/jquery-3.5.1.min.js";

export class Anim {

  constructor() {
    // Prevent transition from showing on load (when console open, etc).
    $(document).ready(() => {
      $("body").addClass("ready");

      this.attach();
    });
  }

  attach() {
    this.inView();
  }

  // Animation using inview
  inView() {
    inView.offset({
      top: 100,
      bottom: 75
    });

    inView('.in-view').on('enter', function (el) {
      if ($(el).hasClass("animated") || $(el).hasClass("animation-done")) {
        return;
      }

      var animation = $(el).data("animation");
      var delay = $(el).data("animation-delay");
      var duration = $(el).data("animation-duration");

      if (delay !== null && delay !== '') {
        $(el).css("animation-delay", delay);
        $(el).css("transition-delay", delay);
      }

      if (duration !== null && duration !== '') {
        $(el).css("animation-duration", duration);
        $(el).css("transition-duration", duration);
      }

      $(el).addClass("animated");
      $(el).addClass(animation);
      $(el).removeClass("in-view");

      // Remove animation on element to enable parallax
      $(el).one('animationend webkitAnimationEnd oAnimationEnd', function () {
        $(el).addClass("animation-done").removeClass("animated").removeClass(animation).removeAttr("style");
      });
    });

  }

  resize() {
    // Disable process animation
    // if (window.viewport().width < 768 && $("#science").length > 0) {
    //   $.each(this.processStepTimelines, $.proxy(function (el, index) {
    //     this.processStepTimelines[el].pause(0);
    //   }, this));
    //   $(".visualize-process .process-steps .step").removeClass("current");
    // } else {
    //   $("#science .visualize-process").attr("style", "");
    // }
  }

  dettach() {
    $(window).off("resize", $.proxy(this.resize, this));
  }

}
